module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iaS11bmxvY2siIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDMyIDMyIiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudGNvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+CiAgICA8cGF0aCBkPSJNNSAxNSBMNSAzMCAyNyAzMCAyNyAxNSBaIE05IDE1IEM5IDcgOSAzIDE2IDMgMjMgMyAyMyA4IDIzIDkgTTE2IDIwIEwxNiAyMyIgLz4KICAgIDxjaXJjbGUgY3g9IjE2IiBjeT0iMjQiIHI9IjEiIC8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-unlock.svg
// module id = mwmO
// module chunks = 50